<template>
    <div>
        <div class="n2-center-container">
            <h3>{{ $t('components.app.unauthorized.title') }}</h3>
            <p>{{ $t('components.app.unauthorized.description') }}</p>
        </div>
    </div>
</template>
<script>
export default {
    methods: {
    }
}
</script>